import { Div, CollectionPrinter } from '@tblabs/truffle';
import { SelectableList } from '../Models/SelectableList';
import { SelectableListItemBox } from './SelectableListItemBox';


export class SelectableListPrinter<T> extends Div
{
    constructor(list: SelectableList<T>, labelSelector: (item: T) => string)
    {
        super("selectable-list");

        this.Append(
            new CollectionPrinter(list.Items, item => new SelectableListItemBox(item, list.Items, labelSelector, (self) => list.Select(self)))
        );
    }
}
